export const getId = obj =>
	obj?.id || obj?._id || (typeof obj === "string" ? obj : undefined);

export const handleImage = image => {
	if (image) {
		if (image.indexOf("http") < 0)
			image = `${process.env.NEXT_PUBLIC_MAIN_URL}${image}`;
		else image = image.replace("https", "http");
	}
	return image || process.env.NEXT_PUBLIC_MAIN_URL;
};

export function getYoutubeId(url) {
	const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
	const match = url?.match(regExp);

	return match && match[2].length === 11 ? match[2] : url;
}
